import React, { useState } from "react";
import { v1 } from "uuid";
import s2 from "../../s1-main/App.module.css";
import GreetingContainer from "./GreetingContainer";

/*
 * 1 - описать тип UserType
 * 2 - указать нужный тип в useState с users
 * 3 - дописать типы и логику функции pureAddUserCallback и проверить её тестами
 * 4 - в файле GreetingContainer.tsx дописать типизацию пропсов
 * 5 - в файле GreetingContainer.tsx указать нужные типы в useState с name и error
 * 6 - в файле GreetingContainer.tsx дописать тип и логику функции setNameCallback
 * 7 - в файле GreetingContainer.tsx дописать логику функций pureAddUser, pureOnBlur, pureOnEnter и проверить их тестами
 * 8 - в файле GreetingContainer.tsx вычислить количество добавленных и имя последнего (totalUsers, lastUserName)
 * 9 - в файле Greeting.tsx дописать типизацию пропсов
 * 10 - в файле Greeting.tsx вычислить inputClass в зависимости от наличия ошибки
 * 11 - сделать стили в соответствии с дизайном
 * */

// types
export type UserType = {
  _id: string;
  name: string;
};

export const pureAddUserCallback = (
  name: string,
  setUsers: (users: UserType[]) => void,
  users: UserType[]
) => {
  const user = {
    _id: v1(),
    name,
  };
  setUsers([...users, user]);
};

const HW3 = () => {
  const [users, setUsers] = useState<UserType[]>([]);

  const addUserCallback = (name: string) => {
    pureAddUserCallback(name.trim(), setUsers, users);
  };

  return (
    <div id={"hw3"}>
      <h2 className={s2.hwTitle}>Homework #3</h2>
      {/*для автоматической проверки дз (не менять)*/}
      <div className={s2.hwBorder}>
        <div className={s2.hw}>
          <GreetingContainer users={users} addUserCallback={addUserCallback} />
        </div>
      </div>
    </div>
  );
};

export default HW3;
